import Repository from "@/plugins/axios";

export default {
  // Получить страницу партнёрской программы
  getPartnershipProgram(params) {
    return Repository.get(`/biennale/partnership`, { params });
  },
  // Получить страницу с описанием площадок
  getSites(biennaleName) {
    return Repository.get(`/biennale/${biennaleName}/sites`);
  },
  // Получить страницу с оттисками прессы
  getPress(biennaleName) {
    return Repository.get(`/biennale/${biennaleName}/press`);
  },
  // Получить страницу команды
  getTeam(biennaleName) {
    return Repository.get(`/biennale/${biennaleName}/team`);
  },
};
